var params = {'3':[
  ['0','R'],  // 0 - product R
  ['R','P','O','C','PR'],  // 1 - shape
  ['0.33','0.5','0.75','1','1.5'],  //  2 - Center Size
  ['I','VS','SI'],  // 3 - Diamond Quality 
  ['STR','TAP','SPT','TWS','CRS','WOV'],  // 4 - Shank
  ['N','S', 'D'],  //  5 - Head
  ['1','2','3'],  // 6 - en   
  ['14','18','PT'],  // 7 - ring metal  
  ['W','Y','R'],  // 8 - shank metal color
  ['0','4','4.5','5','5.5','6','6.5','7','7.5','8','8.5','9'],  // 9 - ring size
  ['J','K','Z','1','2','3','4','5'],  // 10 - Store
  ['0','S','C'],  // 11 - band type
  ['1','2','3'],  // 12 - ben  
  ['14','18','PT'],  // 13 - band metal  
  ['W','Y','R'],  // 14 - band metal color
  ['W','Y','R'],  // 15 - head metal color
  ['D','U','LAB','LEO','FEED'],  // 16 - center color
 
   ]}
// PARAMS
// s - size (thumb,500,2000) default 500
// v - view (0,1,2,3) default = 0
// e - engraving (for r,b1,b2) for add to cart
// u - user diamond for add to cart(6 params)


var TOTAL_PARAM =17  
var ring_list=[0,1,2,3,4,5,6,7,8,9,10];
var band_list=[11,12,13,14,15,16];

var ring_val = [];
var band_val = [];
var ring_val2 = [];
var band_val2 = [];
var version = '3';
var p = params[version];
var base = 35;


var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';

function init() {
  var i;
  for (i in ring_list) {
    ring_val.push(p[ring_list[i]].length);
  }
  for (i in band_list)
    band_val.push(p[band_list[i]].length);
    
  var n = 1;
  for (i = 0; i < ring_val.length; i++) {
    n = n * ring_val[i];
    ring_val2.push(n);
  }
  n = 1;
  for (i = 0; i < band_val.length; i++) {
    n = n * band_val[i];
    band_val2.push(n);
  }
  // alert(ring_val)
  // alert(band_val)
  // alert(ring_val2)
  // alert(band_val2)
}

export function param2sku(in1) {
  var in2 = in1 //.split('-');

  //23+13 >20
  //var new20 = '';
  //if (in2[23] !== 'B') 
  //new20 += 'R';
  //if (in2[22] !== '0') new20 += 'B';
  //if (new20 === '') new20 = 'R';
  //in2[20] = new20;
  //in2[28] = in2[19]; //bs=rs
  //if (in2[7] === 'P1' || in2[7] === 'P2')
  //  in2[16] = 'W';
  //if (in2[23] === '0') {in2[24] = '0';in2[16] = '0';}
  //if (in2[8] === '0') {in2[9] = '0';in2[10] = '0';}
  //if (in2[11] === '0') {in2[12] = '0'}
  //if (in2[27] === '0') {in2[28] = '0'}
  

  var in3 = [];
  var in_ring = [];
  var in_band = [];
  //var j = 0;
  var i;
  var error = '';
  var res;
  if (in2.length < TOTAL_PARAM)
    error += 'param count in less than ' + String(TOTAL_PARAM);
  for (i = 0; i < TOTAL_PARAM; i++) {
    res = p[i].indexOf(in2[i]);
    if (res !== -1)
      in3.push(res);
    else {
      in3.push(0);
      error += 'error: ' + String(in2[i]) + ' not in index array ' + String(i) + ';';
      console.log('ERROR SKU',in1,String(in2[i]),'not in','index',i,in2)
    }
  }
  // alert (in3)
  for (i = 0; i < ring_list.length; i++)
    in_ring.push(in3[ring_list[i]]);
  for (i = 0; i < band_list.length; i++)
    in_band.push(in3[band_list[i]]);
  var sku = version + param2skupart(in_ring, ring_val, ring_val2, base) + '0' + param2skupart(in_band, band_val, band_val2, base);
  // alert(sku)
  return [sku, error];
}

function param2skupart(in1, max_val, max_val2, base) {
  var sku = '';
  //var num = 0;
  var dec = 0;
 // alert(in1)
 // alert(max_val)
 var mul;
 var i;
  for (i = 0; i < max_val.length; i++) {
    if (i === 0)
      mul = 1;
    else
      mul = max_val2[i - 1];
    dec += in1[i] * mul;
  }
  // alert('decX'+String(dec))
  var sk = DecimalToBase(dec, base);
  sku = '';
  for (i = 0; i < sk.length; i++)
    sku = alphabet[sk[i]] + sku;
  return sku;
}

 function sku2param(in1) {
  var resarray = [0,0,0,0,0, 0,0,0,0,0, 0,0,0,0,0 ];
  var in2 = in1.substring(1);
  var in3 = in2.split('0');
  var ring = sku2parampart(in3[0], ring_val2);
  var band = sku2parampart(in3[1], band_val2);
  var i;
  for (i = 0; i < ring.length; i++)
    resarray[ring_list[i]] = ring[i];
  for (i = 0; i < band.length; i++)
    resarray[band_list[i]] = band[i];
  //if (resarray[2] === 3 || resarray[2] === 3)
  //  resarray[18] = 0;
  
  var res = [];
  ///console.log('resarray.length',resarray.length)
  for (i = 0; i < resarray.length; i++) {
    //if (res !== '') res += '-';
    //console.log('resarray[i]',resarray[i])
    res.push( p[i][resarray[i]]);
  }
  return res;
}

function sku2parampart(in2, max_temp) {
  var in1 = [];
  var pos;
  var i;
  for (i = 0; i < in2.length; i++) {
    pos = alphabet.indexOf(in2[i]);
    in1.push(pos);
  }
  var dec = 0;
  var param = [];
  // alert(in1);
  for (i = 0; i < in1.length; i++)
    dec += in1[i] * Math.pow(base, in1.length - i - 1);
  var maxlen = max_temp.length;
  for (i = 0; i < maxlen; i++) {
    if (i === maxlen - 1)
      param.unshift(Math.floor(dec));
    else
      param.unshift(Math.floor(dec / max_temp[maxlen - i - 2]));
    dec = Number(dec % max_temp[maxlen - i - 2]);
  	// alert(dec)
  	// alert(param)
  }
  return param;
}

function __DecimalToBaseRecur__(array, decimal, base) {
  array.push(decimal % base);
  // alert(decimal% base)
  var div = Math.floor(decimal / base);
  if (div === 0)
    return;
  __DecimalToBaseRecur__(array, div, base);
}

function DecimalToBase(decimal, base) {
  var array = [];
  __DecimalToBaseRecur__(array, decimal, base);
  return array;
}
init();
export function sku4band (sku) {
  let res= sku2param(sku)
  //res[20]='B'
  res[0]='0'
  let res2 =param2sku(res)[0]
  //console.log('resB',sku,'>',res2,res)
  return res2
}
export function sku4ring (sku) {
  let res= sku2param(sku)
  res[0]='R'
  res[11]='0'
  let res2 =param2sku(res)[0]
  //console.log('res',sku,'>',res2)
  return res2
}
export function sku2array(in1) {
 // console.log('update SKU 2 PARAM',in1)
     
  let res= sku2param(in1)
  let res2={}
   //  console.log('update SKU 2 PARAM',in1,res)
     res2['ds'] =  res[1]
     res2['dctw'] =  res[2]
     res2['dq'] =  res[3]
     res2['sh'] =    res[4]
     res2['head'] =  res[5]
     res2['ren'] =  res[6]
     res2['rmet'] =  res[7]
     res2['rmetc'] =  res[8]
     res2['hmetc'] =  res[15]
     res2['rs'] =  res[9] 
     res2['store'] = res[10]
     res2['band'] =  res[11] 
     res2['ben'] =  res[12]
     res2['bmet'] =  res[13]
     res2['bmetc'] =  res[14]
     
    if (res2['bmet'] === 'PT' ){
      res2['bmetc'] =  'W'
    }
    if (res2['rmet'] === 'PT' ){
    res2['hmetc'] =  'W'
    res2['rmetc'] =  'W'
  }
  if (res2['head'] === 'N' ){
    res2['hmetc'] =  res2['rmetc']
  }
  
    /*console.log('array',res[29])
     if (res[29] === 'U' && ud ==='D'){
       res2['dq'] =  'I'
     }
 //    console.log('array',res[29],res,res2)*/
     
       // res2['store'] =  res[30] 
    if (window.currentSite === 'kay'){res2['store']= 'K'}
    if (window.currentSite === 'kay'  && res[10] !== 'K')
            { res[10]='K'
            //  res[24]='0'
            //  res[25]='0'
              res2['sku']= param2sku(res)[0]
            //console.log('sku changed from ',in1,'to',res2['sku'])
            }
     if (window.currentSite === 'jared'){res2['store']= 'J'}
     if (window.currentSite === 'jared'  && res[10] !== 'J')
     { res[10]='J'
       res2['sku']= param2sku(res)[0]
    // console.log('sku changed from ',in1,'to',res2['sku'])
     }
if (window.currentSite === 'zales'){res2['store']= 'Z'}
if (window.currentSite === 'zales'  && res[10] !== 'Z')
{ res[10]='Z'
  res2['sku']= param2sku(res)[0]
//console.log('sku changed from ',in1,'to',res2['sku'])
}


  return res2   
  } 


// WEBPACK FOOTER //
// ./src/logic/sku-ver3.js